module.exports = __webpack_public_path__ + "img/polygon-matic-logo.1087d3d6.svg";